import React, { memo } from "react";
import "./ContractInfo.css";

const ContractInfo = memo(
  ({
    contractAddress,
    currentPrice,
    volume24h,
    symbol,
    exchange,
    exchangeType = "futures",
    tickerData,
    isConnected,
    error,
    orderBookLength,
    fundingRate,
  }) => {
    const formatNumber = (num) => {
      if (!num || isNaN(num)) return "0";
      return parseFloat(num).toFixed(6);
    };

    const formatVolume = (vol) => {
      if (!vol || isNaN(vol)) return "0";
      const num = parseFloat(vol);
      if (num >= 1e9) return (num / 1e9).toFixed(2) + "B";
      if (num >= 1e6) return (num / 1e6).toFixed(2) + "M";
      if (num >= 1e3) return (num / 1e3).toFixed(2) + "K";
      return num.toFixed(2);
    };

    const volumeInUSDT = (volume24h || 0) * (currentPrice || 0);
    const exchangeDisplayName = `${exchange.toUpperCase()}`;

    return (
      <div className="contract-info">
        <div className="info-content">
          <div className="info-item">
            <span className="label">Биржа:</span>
            <span className="value">{exchangeDisplayName}</span>
          </div>
          <div className="info-item">
            <span className="label">Цена:</span>
            <span className="value price-value">
              ${formatNumber(currentPrice)}
            </span>
          </div>
          <div className="info-item">
            <span className="label">Объем (USDT):</span>
            <span className="value">{formatVolume(volumeInUSDT)}</span>
          </div>

          {/* Показываем фандинг только для фьючерсов */}
          {exchangeType === "Futures" && (
            <div className="info-item">
              <span className="label">Фандинг:</span>
              <span
                className={`value funding-rate ${
                  fundingRate >= 0 ? "positive" : "negative"
                }`}
              >
                {(fundingRate * 100).toFixed(4)}%
              </span>
            </div>
          )}
        </div>
      </div>
    );
  },
  // Добавляем проверку на изменение символа в условие реиспользования
  (prevProps, nextProps) => {
    return (
      prevProps.symbol === nextProps.symbol &&
      prevProps.currentPrice === nextProps.currentPrice &&
      prevProps.volume24h === nextProps.volume24h &&
      prevProps.fundingRate === nextProps.fundingRate &&
      prevProps.isConnected === nextProps.isConnected
    );
  }
);

ContractInfo.displayName = "ContractInfo";
export default ContractInfo;
